/* tslint:disable */
/* eslint-disable */
/**
 * Careplatform Invite API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: jonas.malik@magello.se
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface VerifyInviteCodeRequest
 */
export interface VerifyInviteCodeRequest {
    /**
     * The invite ID
     * @type {string}
     * @memberof VerifyInviteCodeRequest
     */
    inviteId: string;
    /**
     * Code to verify
     * @type {string}
     * @memberof VerifyInviteCodeRequest
     */
    code: string;
}

export function VerifyInviteCodeRequestFromJSON(json: any): VerifyInviteCodeRequest {
    return VerifyInviteCodeRequestFromJSONTyped(json, false);
}

export function VerifyInviteCodeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): VerifyInviteCodeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'inviteId': json['inviteId'],
        'code': json['code'],
    };
}

export function VerifyInviteCodeRequestToJSON(value?: VerifyInviteCodeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'inviteId': value.inviteId,
        'code': value.code,
    };
}


